import React from "react";
import { roundMoneyValue } from "../../../../utils/functions";

function AddIns(props) {
    const { selectedAddIns } = props;

    const computeAddInsPrice = () => {
        let price = 0;

        selectedAddIns.forEach((additional) => {
            additional.variants.forEach((variant) => {
                let itemPrice = +variant.price;
                price += itemPrice * additional.quantity;
            });
        });

        return roundMoneyValue(price);
    };

    let addInsPrice = computeAddInsPrice();

    return (
        <>
            {selectedAddIns.length > 0 && (
                <>
                    <div className="product-nav__title">
                        Add-Ins Meals
                    </div>
                    <dl className="price">
                        <div className="price__regular">
                            <dd>
                                <span className="price-item price-item--regular">
                                    ${addInsPrice}
                                </span>
                            </dd>
                        </div>
                    </dl>{" "}
                </>
            )}
        </>
    );
}

export default AddIns;